import { useCallback } from 'react';
import { FieldValues } from 'react-hook-form';
import { ApiServerHandlerOptions, isApiServerError } from '@cp/utils/apiServer/errorHandler';
import { useApiServerErrorHandler } from 'src/shared/apiServer';

export const useErrorHandler = () => {
  const handleApiServerError = useApiServerErrorHandler();
  return useCallback(
    <F extends FieldValues = FieldValues, FC = unknown>(err: unknown, options: ApiServerHandlerOptions<F, FC> = {}) => {
      if (isApiServerError(err)) {
        return handleApiServerError(err, options);
      }
      throw err;
    },
    [handleApiServerError],
  );
};
